module.exports = __webpack_public_path__ + "static/media/truck.df853639.svg";